export default __webpack_public_path__ + "static/media/CameliaLovelace.cffe16ac.png";